import { getRoomTypes, getWallTypes } from '@/services/api';

export default {
  namespaced: true,

  state: {
    roomTypes: [],
    wallTypes: [],
  },

  actions: {
    async fetchRoomTypes({ commit }) {
      const { data } = await getRoomTypes();

      commit('setRoomTypes', data.map((roomType) => roomType.name) || []);
    },

    async fetchWallTypes({ commit }) {
      const { data } = await getWallTypes();

      commit('setWallTypes', data.map((wallType) => wallType.name) || []);
    },
  },

  mutations: {
    setRoomTypes(state, roomTypes) {
      state.roomTypes = roomTypes;
    },

    setWallTypes(state, wallTypes) {
      state.wallTypes = wallTypes;
    },
  },
};
